export const setLoading = 'setLoading';
